<template>
  <div class="common-title">
    <i v-if="needBack" class="common-back j-back-dcount" v-datain="{ext3: '点击返回按钮'}" @click="back"></i>
    <!-- <i class="header-logo"></i> -->
    <span class="header-text">
      <slot>G妹儲值中心</slot>
    </span>
    <i v-if="fromSDK" class="common-close j-close-dcount" v-datain="{ext3: '点击关闭webview'}" @click="close"></i>
  </div>
</template>

<script>
export default {
  name: 'vHeader',
  props: {
    needBack: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isPortrait () {
      return this.$store.getters.getDeviceDirection
    }
  },
  data () {
    return {
      fromSDK: false
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    close () {
      if (this.fromSDK) {
        if (window.closeWebview) {
          window.closeWebview()
        } else if (window.sdkCtrl && window.sdkCtrl.closeWebview) {
          window.sdkCtrl.closeWebview()
        }
      }
    }
  },
  created () {
    this.fromSDK = +window.sessionStorage.getItem('fromSDK') === 1
  }
}
</script>

<style lang="scss" scoped>
.common-title {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  font-size: 18px;
  font-weight: 600;
  color: #e97d30;
  line-height: 36px;
  text-align: center;
  z-index: 99;
  // position: relative;
  background-color: #fff;
  box-shadow: 0px 2px 6px -3px #ccc;
  .header-logo {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(../assets/logo.png);
  }
  .header-text {
    display: inline-block;
    vertical-align: middle;
  }
  .common-back {
    top: 50%;
    left: 16.5px;
    width: 7px;
    height: 12px;
    margin-top: -8px;
    position: absolute;
    background-size: 100% 100%;
    background-image: url(../assets/back.png);
  }
  .common-close {
    position: absolute;
    top: 50%;
    right: 5px;
    margin: 3px;
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    background: transparent;
    transform: translate(0, -50%);
    transform: translate(0, -50%) \9;
    &:after,
    &:before {
      position: absolute;
      left: 11px;
      width: 1px;
      content: " ";
      height: 20px;
      background: #666666;
      transform: rotate(45deg);
    }
    &:before {
      transform: rotate(-45deg);
    }
  }
}
</style>
